export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8376.6e440d18.jpg";